import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    instruments: [],
    favourites: []
  },
  actions: actions,
  mutations: mutations,
  getters: getters
}
